import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAirbnbComponent } from './simple-icons-airbnb.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAirbnbComponent ],
    exports:      [ SimpleIconsAirbnbComponent ],
    bootstrap:    []
})
export class SimpleIconsAirbnbModule {}
